import styled, { css } from 'styled-components';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { Table } from 'ui/table';
import { HelpToggletip } from 'ui/tooltip';
import { spacing, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p235: pxToRem(235),
  p296: pxToRem(296),
  p336: pxToRem(336),
  p304: pxToRem(304),
};

export const SharedColumnSpacing = css`
  & > div {
    padding: ${spacing.base};
  }
  & > div:nth-child(1) {
    min-width: ${customSpacing.p336};
    max-width: ${customSpacing.p336};
    padding: ${spacing.base};
  }
  & > div:nth-child(2) {
    min-width: ${customSpacing.p235};
    max-width: ${customSpacing.p235};
    padding: ${spacing.base};
  }
`;

export const StyledVariantTableHeader = styled(TableHeader)`
  ${colors.textPrimary};
  ${SharedColumnSpacing}
`;

export const StyledVariantTableRows = styled(TableRows)`
  ${SharedColumnSpacing}
`;

export const ColumnSpacedToggletip = styled(HelpToggletip)`
  margin-left: ${spacing.threeEights};
  top: -${spacing.single};
`;

export const StyledVariantTable = styled(Table)`
  border-spacing: 0;
  border-collapse: separate;
`;
